import {
  Component,
  effect,
  inject,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { FaqInterface } from "src/app/core/interfaces/faq-interface";
import { Loader } from "src/app/shared/components/loader/loader";
import { Icon } from "src/app/shared/components/utils/icon/icon";
import { SafeHtmlPipe } from "src/app/shared/pipes/safe-html.pipe";
import { FaqService } from "../../services/faq/faq-service";
import { Button } from "src/app/shared/components/utils/button/button";
import { TranslocoModule } from "@jsverse/transloco";
import { LanguageService } from "src/app/core/services/language-service";

@Component({
  selector: "app-faq-page",
  imports: [Icon, SafeHtmlPipe, Loader, Button, TranslocoModule],
  templateUrl: "./faq-page.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      details .icon-closed {
        display: block;
      }

      details .icon-open {
        display: none;
      }

      details[open] .icon-closed {
        display: none;
      }

      details[open] .icon-open {
        display: block;
      }
    `,
  ],
})
export class FaqPage implements OnInit {
  private readonly faqService = inject(FaqService);
  private readonly languageService = inject(LanguageService);
  router = inject(Router);
  loading = signal<boolean>(false);
  faqs: FaqInterface[] = [];

  constructor() {
    effect(() => {
      this.languageService.currentLanguage();
      this.loadFaq();
    });
  }

  async ngOnInit(): Promise<void> {
    await this.loadFaq();
  }

  private async loadFaq(): Promise<void> {
    this.loading.set(true);
    try {
      this.faqs = await this.faqService.getFaqs();
    } catch (error) {
      console.error("Erreur lors du chargement des FAQs :", error);
    } finally {
      this.loading.set(false);
    }
  }

  redirectToHomepage(): void {
    this.router.navigate(["/"]);
  }
}
